class WPShopifyAPI {

    constructor() {
        this.ajaxUrl = window.WPShopify.ajax_url || 'https://miniluxe.com/wp-admin/admin-ajax.php';//'https://newminiluxedev.wpengine.com/wp-admin/admin-ajax.php';//;'http://ml.test/wp-admin/admin-ajax.php';
        this.el = this.createRoot('WPShopify', 'wp-shopify-root');
        this.$el = jQuery(this.el);
        this.headerEl = document.getElementById('header');
        this.blocks = window.WPShopify.blockInstances; // we put here reference to global object.
        // this.requestData();

        if(this.attachRoot()){
            this.initEvents();
        }

    }

    createRoot(id, className) {
        const el = document.createElement('div');
        el.id = id;
        el.classList.add(className);
        return el;
    }

    attachRoot() {
        const attachTo = document.getElementById('MainContent');
        if(attachTo instanceof Element){
            attachTo.appendChild(this.el);
            return true;
        }
        return false;
    }

    initEvents() {
        // this.$el.on('click','.close-btn', this.handleCloseBar.bind(this) );
    }


    requestData() {

        const productFormEl = document.querySelector('[data-product-form]');
        if (!productFormEl) {
            return false;
        }

        const productHandle = productFormEl.getAttribute('data-product-handle');
        window.console.log('WPShopify: loading blocks for:', productHandle);

        return jQuery.ajax({
            method: 'POST',
            url: this.ajaxUrl,
            data: {
                action: 'LoadProductBlocks',
                handle: productHandle,
            },
            context: this,

        }).done((response) => {

            window.console.log('WPShopify:  I\'ve got blocks data :) ', response);

            if (response.data) {

                this.injectBlocks(response.data);

            }

        });
    }

    injectBlocks(data) {

        if (data.stylesheets && Array.isArray(data.stylesheets)) {
            data.stylesheets.forEach((stylesheet) => {
                this.injectStylesheet(stylesheet);
            });
        }

        if (data.scripts && Array.isArray(data.scripts)) {
            data.scripts.forEach((src) => {
                this.injectJSFile(src, this.initializeWaitingBlocks.bind(this));
            });
        }

        const $blocks = jQuery(data.html);

        $blocks.each((index, blockEl) => {

            // eslint-disable-next-line no-undef
            if (!(blockEl instanceof HTMLElement)) {
                return;
            }

            const id = `wpshopify_dynamic_${index}`;

            blockEl.setAttribute('data-wpshopify-id', id);
            const blockInitFunctionName = blockEl.getAttribute('data-init-ajax-block');

            if (blockInitFunctionName) {

                /* This means we should instantiate block when js is available */
                blockEl.setAttribute('data-waiting-for-init', true);
            }

            // push block to be later initialized.
            this.blocks[id] = {
                el: blockEl,
                id,
                blockInitFunctionName,
            };

            this.el.appendChild(this.blocks[id].el);

            this.initializeBlock(id);


        });

    }

    initializeBlock(id) {

        const blockInitFunctionName = this.blocks[id].blockInitFunctionName;

        if ( window.WPShopify.blocksInits[blockInitFunctionName] &&
            typeof window.WPShopify.blocksInits[blockInitFunctionName] === 'function' ) {

            if (!this.blocks[id].instance) {

                this.blocks[id].instance = window.WPShopify.blocksInits[blockInitFunctionName](this.blocks[id].el);
            }

            /* in case constructor of js block forgot to remove this dom flag do it. */
            if (this.blocks[id].el.hasAttribute('data-waiting-for-init')) {
                this.blocks[id].el.removeAttribute('data-waiting-for-init');
            }
            // }


        }

        jQuery(document).trigger('wpshopify.block_loaded', [ this.blocks[id].el, id ] );

    }

    initializeWaitingBlocks() {

        this.blocks.forEach((block) => {
            if (block.id ) {
                this.initializeBlock(block.id);
            }
        });

    }


    injectStylesheet(stylesheetDef) {

        const src = stylesheetDef.src || '';
        const inFooter = stylesheetDef.inFooter || false;

        if (src) {
            const linkEl = document.createElement('link');
            linkEl.setAttribute('rel', 'stylesheet');
            linkEl.setAttribute('href', src);
            linkEl.setAttribute('data-from', 'wpshopify');
            if (inFooter) {
                document.body.appendChild(linkEl);
            } else {
                document.head.appendChild(linkEl);
            }
        }

    }

    injectJSFile(src, callback) {

        const callbackFunc = callback || this.initializeWaitingBlocks.bind(this);
        const script = document.createElement('script');
        script.src = src;

        if (script.readyState) {
            // IE, incl. IE9
            // eslint-disable-next-line shopify/prefer-early-return
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    callbackFunc();
                }
            };

        } else {
            script.onload = function() {
                // Other browsers
                callbackFunc();
            };
        }

        document.getElementsByTagName('head')[0].appendChild(script);
    }

    getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            // eslint-disable-next-line prefer-template, no-useless-escape
            '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)',
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }

    setCookie(name, value, options = {}) {

        let expires = options.expires;

        if (typeof expires === 'number' && expires) {
            const date = new Date();
            date.setTime(date.getTime() + (expires * 1000));
            options.expires = date;
            expires = date;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        const encodedValue = encodeURIComponent(value);

        let updatedCookie = `${name}=${encodedValue}`;

        for (const propName in options) {
            if (options.hasOwnProperty(propName)) {
                updatedCookie += `;${propName}`;
                const propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += `=${propValue}`;
                }
            }
        }

        document.cookie = updatedCookie;
    }

    static initialize() {

        window.WPShopify = window.WPShopify || {};
        window.WPShopify.blockInstances = window.WPShopify.blockInstances || {};
        window.WPShopify.blocksInits = window.WPShopify.blocksInits || {};
        window.WPShopify.api = new WPShopifyAPI();

        window.console.log('WPShopify Instantiated');
    }

}

WPShopifyAPI.initialize();
